// Re-export TipTap editor as RichTextEditor for backward compatibility
import TipTapEditor from './TipTapEditor';
export default TipTapEditor;
